import { LogLayer, LogLayerConfig, ILogLayer } from 'loglayer';

export const createLogLayer = (config: LogLayerConfig): ILogLayer => new LogLayer(config);
